// extracted by mini-css-extract-plugin
export default {"businessSummaryContainer":"BusinessSummary_businessSummaryContainer__e6Y21","headerContainer":"BusinessSummary_headerContainer__QqtVJ"};